<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal" id="auto_bookmark_table_of_contents_1">To Tracy Timmons-Gray. Thank you for your kindness, and the challenge to write a story where the romance is the subplot.</p>
<p class="P_Normal">To Siobhan Muir, the brilliant mind and sharp eyes behind Thursday Threads and Teddy Bear Thursdays. This story would never have been written without you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?782a5edb